import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import HostClusterHostAdd from "./HostClusterHostAdd";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { DropdownType } from "../../base/CustomDropdown";
import { convertUnit, getUnit, parseLocaleDatetime } from "common/util";



export interface HostClusterDetailData {
    host_cluster_id: string,
    host_cluster_name: string,
    host_cluster_type_code: string,
    create_ts: string,
    update_ts: string,
    hosts: {
        host_id: string,
        host_name: string,
        hypervisor_name: string,
        host_status_code: string
    },
    availability_zone: {
        availability_zone_id: string,
        availability_zone_name: string,
        availability_zone_active_yn: boolean,
        create_ts: string,
        update_ts: string,
    },
    availability_zone_name: string,
    region: {
        region_id: string,
        region_name: string,
    },
    host_count: number,
    memory_capacity_mb: number,
    vcpu_count: number,
    vm_count: number

}


export const initHostClusterDetailData = {
    host_cluster_id: '',
    host_cluster_name: '',
    host_cluster_type_code: 'NRM',
    create_ts: '',
    update_ts: '',
    availability_zone_name: '',
    availability_zone: {
        availability_zone_id: '',
        availability_zone_name: '',
        availability_zone_active_yn: false,
        create_ts: '',
        update_ts: '',
    },
    region: {
        region_id: '',
        region_name: '',
    },
    hosts: {
        host_id: '',
        host_name: '',
        hypervisor_name: '',
        host_status_code: '',
    },
    host_count: 0,
    vm_count: 0,
    vcpu_count: 0,
    memory_capacity_mb: 0,
}




interface HostClustersData {
    host_cluster_id: string,
    host_cluster_name: string,
    host_cluster_type_code: string,
    create_ts: string,
    update_ts: string,
    availability_zone: {
        availability_zone_id: string,
        availability_zone_name: string,
        availability_zone_active_yn: boolean,
        create_ts: string,
        update_ts: string,
    }
}


export interface HostClusterTableData {
    host_id: string,
    host_name: string,
    hypervisor_name: string,
    host_status_code: string,
    ip_address: string,
    cpu_arch: string,
    cpu_vendor: string,
    cpu_model: string,
    cpu_socket_count: number,
    cpu_core_count: number,
    cpu_thread_count: number,
    up_yn: boolean,
    vcpu_total_count: number,
    memory_total_capacity_mb: number,
    local_storage_total_capacity_gb: number,
    vcpu_used_count: number,
    memory_used_capacity_mb: number,
    local_storage_used_capacity_gb: number,
    vm_count: number,
    host_clusters: HostClustersData[],
    region: {
        region_id: string,
        region_name: string,
    },
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("HOST_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "HOST_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "HOST_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "HOST_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("HOST_NAME_TEXT"),
        accessor: "host_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("HOST_VM_COUNT_TEXT"),
        accessor: "vm_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}</div>
        )
    },
    {
        Header: i18n.t("vCPU"),
        accessor: "vcpu_used_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color:"#4aaad4"}}>{value} Cores</div>
        )
    },
    {
        Header: i18n.t("Memory"),
        accessor: "memory_used_capacity_mb",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, color:"#7560bd"}}>{convertUnit(value)} {getUnit(value)}</div>
        )
    },
    {
        Header: i18n.t("HOST_STATUS_TEXT"),
        accessor: "host_status_code",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                Up
            </div>
        )
    },
    {
        Header: i18n.t("HOST_STATE_TEXT"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{value ? 'Y' : 'N'}</div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "host_clusters[0].update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : "-"}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "host_clusters[0].create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer,...className.dateContainer}}>
                {value ? parseLocaleDatetime(value) : "-"}
            </div>
        )
    },
];


export const hostClusterHostAddModalContent = {
    title: i18n.t("HOST_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("ADD_TEXT")
        },
    ],
    innerComponent: <HostClusterHostAdd />,
}

export const hostClusterType:DropdownType[] = [
    {
        value: "NRM",
        label: i18n.t("NORMAL_TYPE_TEXT")
    },
    {
        value: "CMP",
        label: i18n.t("COMPUTE_TYPE_TEXT")
    },
    {
        value: "MEM",
        label: i18n.t("MEMORY_TYPE_TEXT")
    },
    {
        value: "GPU",
        label: i18n.t("GPU_TYPE_TEXT")
    },
    {
        value: "STRG",
        label: i18n.t("STORAGE_TYPE_TEXT")
    },
    {
        value: "NET",
        label: i18n.t("NIC_TYPE_TEXT")
    },
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}